import { render, staticRenderFns } from "./BecomePro.vue?vue&type=template&id=1e24cc3c&scoped=true&"
import script from "./BecomePro.vue?vue&type=script&lang=js&"
export * from "./BecomePro.vue?vue&type=script&lang=js&"
import style0 from "./BecomePro.vue?vue&type=style&index=0&id=1e24cc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e24cc3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e24cc3c')) {
      api.createRecord('1e24cc3c', component.options)
    } else {
      api.reload('1e24cc3c', component.options)
    }
    module.hot.accept("./BecomePro.vue?vue&type=template&id=1e24cc3c&scoped=true&", function () {
      api.rerender('1e24cc3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/BecomePro.vue"
export default component.exports